import { SmartTagRuntimeVO } from 'tag/ts/smart_tag/utilities/SmartTagRuntimeVO';
export const getSmartTagRuntimeVO = (runtimeVO = window?.SmartTag?.runtimeVO || new SmartTagRuntimeVO()) => {
    return runtimeVO;
};
